module.exports = __webpack_public_path__ + "static/media/phone-off.dd690524.svg";